/* efx-pdp-uni.js — T-PDP-UNI, 2026-08-31.
 *
 * ONE job, additive only: route the plain universal-PDP add-to-cart through
 * /cart/add.js so the EF cart drawer opens, instead of the native form POST to
 * /cart/add that navigates the customer off the product page to the cart page.
 *
 * Why this exists: assets/ef-uni-pdp.js binds the quantity stepper, the variant
 * picker and the Express Checkout button on #efUniForm, but NOT its submit event,
 * and nothing else in the theme intercepts it either (checked: ef-cart-drawer-2.js,
 * efx.js, ef-pdp-standard.js — that last one binds a different form id). So every
 * tool set, fireplace, mantel shelf, grill and accessory on templates/product.json
 * left the PDP on Add to Cart while the rest of the store opens the drawer.
 *
 * Cart requests are never automatically retried after an error: the server may
 * already have accepted an interrupted request. Preserve selections, explain the
 * result and let the customer inspect their cart before an explicit retry.
 * Pending state is shared with the universal PDP Express Checkout handler.
 *
 * Not involved in the firepit (ef-cfg-firepits → Draft Order Worker) or gas-log
 * (ef-orderform-gaslogs → its own /cart/add.js + drawer) paths: neither renders
 * #efUniForm.
 */
(function () {
  'use strict';

  if (window.EFX_UNI_ATC) return;          // never bind twice
  window.EFX_UNI_ATC = true;

  function openDrawer() {
    if (window.EFCartDrawer && typeof window.EFCartDrawer.open === 'function') {
      window.EFCartDrawer.open();
      return true;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    return false;
  }

  function init() {
    var form = document.getElementById('efUniForm');
    if (!form) return;                      // studio product — nothing to wrap

    var btn = document.getElementById('efUniATC');
    var label = btn ? btn.querySelector('[data-atc-text]') : null;
    var busy = false;
    var express = document.getElementById('efUniExpressCheckout');
    function cartState(pending) {
      busy = pending;
      form.dataset.efUniCartPending = pending ? 'true' : 'false';
      form.setAttribute('aria-busy', pending ? 'true' : 'false');
      if (pending) {
        if (btn) btn.disabled = true;
        if (express) express.disabled = true;
        var oldError = document.getElementById('efUniCartError');
        if (oldError) oldError.hidden = true;
      }
      form.dispatchEvent(new Event('ef:uni-cart-state'));
    }
    form._efUniShowCartError = function (message) {
      var error = document.getElementById('efUniCartError');
      if (!error) {
        error = document.createElement('p');
        error.id = 'efUniCartError';
        error.setAttribute('role', 'alert');
        error.setAttribute('tabindex', '-1');
        error.style.cssText = 'margin:12px 0;line-height:1.5';
        form.appendChild(error);
      }
      error.textContent = message + ' ';
      var link = document.createElement('a');
      link.href = '/cart';
      link.textContent = 'View your cart';
      error.appendChild(link);
      error.hidden = false;
      error.focus();
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || form.dataset.efUniCartPending === 'true') return;
      var idInput = document.getElementById('efUniVariantId');
      var variantId = idInput && Number(idInput.value);
      if (!Number.isSafeInteger(variantId) || variantId <= 0) {
        form._efUniShowCartError('Choose an available product option before adding it to your cart.');
        return;
      }
      if (form.hasAttribute('data-ef-tool-set-form') && !form.reportValidity()) return;
      cartState(true);

      var qtyInput = form.querySelector('.ef-uni-qty__input');
      var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
      var restore = label ? label.textContent : null;
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [Object.assign({ id: variantId, quantity: qty }, form.hasAttribute('data-ef-tool-set-form') ? { properties: { Finish: form.querySelector('[data-tool-finish]:checked').value } } : {})] })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart-add ' + r.status); return r.json(); })
        .then(function (data) {
          if (!data || Number(data.status) >= 400 || data.errors || data.error ||
              !(data.id || (Array.isArray(data.items) && data.items.length))) {
            throw new Error('cart-add-invalid-response');
          }
          if (label) label.textContent = 'Added to cart';
          openDrawer();
          setTimeout(function () {
            if (btn) btn.disabled = false;
            if (label && restore !== null) label.textContent = restore;
            cartState(false);
          }, 1600);
        })
        .catch(function (err) {
          console.warn('[efx-pdp-uni] cart result could not be confirmed', err);
          if (btn) btn.disabled = false;
          if (label && restore !== null) label.textContent = restore;
          cartState(false);
          form._efUniShowCartError("We couldn't confirm whether this item was added. Check your cart before trying again.");
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
